import classNames from "classnames";
import { InvalidatedIcon, SubmittedIcon, ValidatedIcon } from "components/atoms/Icon";
import styles from "./ResultCards.module.scss";

interface ResultCardsProps {
    buildingsSubmitted: number;
    buildingsInvalid: number;
    buildingsValid: number;
}

function ResultCards({ buildingsSubmitted, buildingsInvalid, buildingsValid }: ResultCardsProps) {
    return (
        <div>
            <div className={styles.container}>
                <div className={classNames(styles.card, styles.submitted)}>
                    <div className={styles.number}>{buildingsSubmitted}</div>
                    <div className={styles.subContainer}>
                        <SubmittedIcon /> SUBMITTED
                    </div>
                </div>
                <div className={classNames(styles.card, styles.invalid, styles.success)}>
                    <div className={styles.number}>{buildingsValid}</div>
                    <div className={styles.subContainer}>
                        <ValidatedIcon />
                        VALID
                    </div>
                </div>
                <div className={classNames(styles.card, styles.invalid, styles.error)}>
                    <div className={styles.number}>{buildingsInvalid}</div>
                    <div className={styles.subContainer}>
                        <InvalidatedIcon />
                        INVALID
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResultCards;
